import React from 'react';
import DashboardView from './components/DashboardView';
import { checkAccess } from '../../utilities/userAccess';
import Error from '../../components/Error';
import { useSearchParams } from 'react-router-dom';
import HeadingContainer from '../../components/header/HeadingContainer';

const Analytics = (props) => {
  const headerTitle = props.location?.state?.headerTitle || null;
    const [searchParams] = useSearchParams();
  
   const clientId = searchParams.get("clientid");
  return (
    <>
      {checkAccess('3')
        ? (
          <DashboardView headerTitle={headerTitle} clientId={clientId} />
        )
        : <Error line1="Access Denied" line2="" line3="" />
        }
    </>
  );
};

export default Analytics;
